import moment from "moment";
import { mapGetters } from "vuex";
import accessibilityMixin from "./accessibility";

const myMixin = {
  filters: {
    moment(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    momentTime(date) {
      return moment(date).format("HH:mm");
    },
    DatePrint(date) {
      //  21, Jan 2021
      return moment(date).format("DD, MMM YYYY");
    },
    yyyymmdd(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    created_at(date) {
      // if date is null or undefined return 0
      if (date === null || date === undefined) return "";
      return moment(date).format("DD-MM-YYYY");
    },

    NumberFormat(val) {
      // format number with commas and smart decimal handling
      if (val === null || val === undefined) return "0";
      // if string convert to number
      if (typeof val === "string") {
        val = parseFloat(val);
      }

      // Check if the number is a whole number (no decimal part)
      if (val % 1 === 0) {
        // For whole numbers, format without decimals
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        // For decimal numbers, format with 2 decimal places
        return val
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    ToNumber(val) {
      // val must not null or undefined
      if (val === null || val === undefined) return "0";

      //  format number  with commas
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    nameLimit(val) {
      if (!val) return "";
      // limit name to 20 character
      if (val.length > 20) {
        return val.substring(0, 20) + "...";
      }
      return val;
    },
    numberToLetter(val) {
      if (val === null || val === undefined || val === "") return "ສູນ";

      // Convert to number and handle decimals
      let num = parseFloat(val);
      if (isNaN(num)) return "ສູນ";

      // Handle zero
      if (num === 0) return "ສູນ";

      // Handle negative numbers - store flag and convert to positive
      const isNegative = num < 0;
      if (isNegative) {
        num = -num;
      }

      // Remove decimals for whole number conversion
      num = Math.floor(num);

      // Lao number words
      const units = [
        "",
        "ໜຶ່ງ",
        "ສອງ",
        "ສາມ",
        "ສີ່",
        "ຫ້າ",
        "ຫົກ",
        "ເຈັດ",
        "ແປດ",
        "ເກົ້າ",
      ];

      const tens = [
        "",
        "ສິບ",
        "ຊາວ",
        "ສາມສິບ",
        "ສີ່ສິບ",
        "ຫ້າສິບ",
        "ຫົກສິບ",
        "ເຈັດສິບ",
        "ແປດສິບ",
        "ເກົ້າສິບ",
      ];

      // Convert number to string and pad with zeros
      const numStr = num.toString();
      const numLength = numStr.length;

      // Helper function to convert 1-9
      const convertUnits = (n) => {
        return units[n] || "";
      };

      // Helper function to convert 10-99
      const convertTens = (n) => {
        if (n < 10) return convertUnits(n);
        if (n < 20) {
          if (n === 10) return "ສິບ";
          return "ສິບ" + convertUnits(n % 10);
        }
        const ten = Math.floor(n / 10);
        const unit = n % 10;
        if (unit === 0) {
          return tens[ten];
        }
        return tens[ten] + convertUnits(unit);
      };

      // Helper function to convert 100-999
      const convertHundreds = (n) => {
        if (n < 100) return convertTens(n);
        const hundred = Math.floor(n / 100);
        const remainder = n % 100;
        let result = "";
        if (hundred === 1) {
          result = "ຮ້ອຍ";
        } else {
          result = convertUnits(hundred) + "ຮ້ອຍ";
        }
        if (remainder > 0) {
          result += convertTens(remainder);
        }
        return result;
      };

      // Helper function to convert 1000-9999
      const convertThousands = (n) => {
        if (n < 1000) return convertHundreds(n);
        const thousand = Math.floor(n / 1000);
        const remainder = n % 1000;
        let result = "";
        if (thousand === 1) {
          result = "ພັນ";
        } else {
          result = convertUnits(thousand) + "ພັນ";
        }
        if (remainder > 0) {
          if (remainder < 100) {
            result += convertTens(remainder);
          } else {
            result += convertHundreds(remainder);
          }
        }
        return result;
      };

      // Helper function to convert 10000-99999
      const convertTenThousands = (n) => {
        if (n < 10000) return convertThousands(n);
        const tenThousand = Math.floor(n / 10000);
        const remainder = n % 10000;
        let result = "";
        if (tenThousand === 1) {
          result = "ໝື່ນ";
        } else {
          result = convertUnits(tenThousand) + "ໝື່ນ";
        }
        if (remainder > 0) {
          if (remainder < 1000) {
            if (remainder < 100) {
              result += convertTens(remainder);
            } else {
              result += convertHundreds(remainder);
            }
          } else {
            result += convertThousands(remainder);
          }
        }
        return result;
      };

      // Helper function to convert 100000-999999
      const convertHundredThousands = (n) => {
        if (n < 100000) return convertTenThousands(n);
        const hundredThousand = Math.floor(n / 100000);
        const remainder = n % 100000;
        let result = "";
        if (hundredThousand === 1) {
          result = "ແສນ";
        } else {
          result = convertUnits(hundredThousand) + "ແສນ";
        }
        if (remainder > 0) {
          if (remainder < 10000) {
            if (remainder < 1000) {
              if (remainder < 100) {
                result += convertTens(remainder);
              } else {
                result += convertHundreds(remainder);
              }
            } else {
              result += convertThousands(remainder);
            }
          } else {
            result += convertTenThousands(remainder);
          }
        }
        return result;
      };

      // Helper function to convert millions and above
      const convertMillions = (n) => {
        if (n < 1000000) return convertHundredThousands(n);
        const million = Math.floor(n / 1000000);
        const remainder = n % 1000000;
        let result = "";
        if (million === 1) {
          result = "ລ້ານ";
        } else {
          result = convertUnits(million) + "ລ້ານ";
        }
        if (remainder > 0) {
          result += convertHundredThousands(remainder);
        }
        return result;
      };

      // Main conversion logic
      let result = "";
      if (num < 10) {
        result = convertUnits(num);
      } else if (num < 100) {
        result = convertTens(num);
      } else if (num < 1000) {
        result = convertHundreds(num);
      } else if (num < 10000) {
        result = convertThousands(num);
      } else if (num < 100000) {
        result = convertTenThousands(num);
      } else if (num < 1000000) {
        result = convertHundredThousands(num);
      } else {
        result = convertMillions(num);
      }

      // Add negative prefix if needed
      if (isNegative) {
        result = "ລົບ " + result;
      }

      return result;
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      taxInclude: "auth/tax_include",
      tax: "auth/tax",
      tax_rate: "auth/tax_rate",
      store_type: "auth/store_type",
    }),
    /**
     * Page title for the app-bar header (like the sale page):
     * uses route meta.title when set, else the translated route name,
     * else a readable prettified fallback (snake_case -> Title Case).
     */
    pageTitle() {
      const route = this.$route;
      if (!route) return "";
      const key = (route.meta && route.meta.title) || route.name || "";
      if (!key) return "";
      try {
        if (this.$te && this.$te(key)) {
          return this.$t(key);
        }
      } catch (_) {
        /* ignore — fall back to prettified name */
      }
      return String(key)
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    is_decimal() {
      if (
        this.user &&
        this.user.stores &&
        this.user.stores.is_decimal !== null &&
        this.user.stores.is_decimal !== undefined
      ) {
        console.log("is_decimal", this.user.stores.is_decimal);
        return this.user.stores.is_decimal;
      }
      return 0;
    },
    cartItemQty() {
      const cart = this.defineStore.cart;
      // 4 items | 10 products
      // ToNumber
      const item = this.$options.filters.ToNumber(cart.length);
      const product = cart.reduce((acc, item) => acc + item.qty, 0);
      const products_format = this.$options.filters.ToNumber(product);
      const itemText = item > 1 ? "items" : "item";
      return `${item} ${this.$t(itemText)} | ${products_format} ${this.$t(
        "quantity"
      )}`;
    },
    localeKey() {
      const local = this.$i18n.locale;
      if (local === "en") return "name_en";
      if (local === "th") return "name_th";
      if (local === "cn" || local === "ch") return "name_cn";
      return "name_la";
    },
    /** Category model fields: en_name, th_name, cn_name, la_name */
    categoryLocaleKey() {
      const local = this.$i18n.locale;
      if (local === "en") return "en_name";
      if (local === "th") return "th_name";
      if (local === "cn" || local === "ch") return "cn_name";
      return "la_name";
    },
    /** Tables + kitchen flows (restaurant-style). */
    hasTables() {
      return (
        this.store_type === "RESTAURANT" || this.store_type === "BUFFET"
      );
    },
    isBuffet() {
      return this.store_type === "BUFFET";
    },
    currency() {
      // 'USD', 'THB', 'LAK'
      if (!this.user || !this.user.stores || !this.user.stores.currency) {
        return "₭";
      }
      switch (this.user.stores.currency) {
        case "USD":
          return "$";
        case "THB":
          return "฿";
        default:
          return "₭";
      }
    },
  },
  methods: {
    /**
     * Sale grid / cart: show Free when the backend marks this product's category
     * as buffet-included for the current table (via products_paginate?table_id=...).
     */
    isBuffetIncludedProduct(product) {
      if (!this.isBuffet) {
        return false;
      }
      const flag = product?.category?.is_buffet_included;
      return flag === true || flag === 1;
    },

    moneyFormat(val) {
      if (val != null && val != undefined && val != "" && val != 0) {
        return Help.moneyFormat(val);
      } else {
        return "0";
      }
    },
    moneyFormatPrint(item) {
      if (item != null && item != undefined) {
        return Help.moneyFormatPrint(item);
      }
    },
    // Amount formatted with the row's own currency, e.g. "1,210₭" — use this
    // instead of a separate currency column next to a price column.
    priceWithCurrency(num, currency) {
      return Help.priceWithCurrency(num, currency);
    },
    IMAGES(val) {
      // check if val is contain http or https
      if (val === null || val === undefined) {
        return "/images/no_photo.jpg";
      } else if (val.includes("http") || val.includes("https")) {
        return val;
      } else {
        const BASEURL = process.env.VUE_APP_BASE_URL;
        return `${BASEURL}/uploads/${val}`;
      }
    },
    getColor(index) {
      const colors = [
        "#00BCD4", // cyan
        "#009688", // teal
        "#2196F3", // blue
        "#3F51B5", // indigo
        "#673AB7", // deep-purple
        "#607D8B", // blue-grey
        "#4CAF50", // green
        "#FF9800", // orange
        "#FF5722", // deep-orange
        "#795548", // brown
      ];
      return colors[index % colors.length];
    },

    CompareArray(array1, array2) {
      var result = [];
      array1.map((item1, index) => {
        array2.map((item2, index) => {
          if (item1.id === item2.id && item1.stock != item2.stock) {
            if (
              item1.price_buy === item2.price_buy &&
              item1.price_sale === item2.price_sale
            ) {
              // same product id
              // same price buy
              // same price sale
              // just update the stock price
              const data = {
                id: item2.id,
                vendor_id: Help.getId(item2.vendor_id),
                stock: item2.stock,
              };
              data.status = false;
              result.push(data);
            } else if (
              item1.price_buy != item2.price_buy ||
              item1.price_sale != item2.price_sale
            ) {
              // same product id
              // create the new product
              // cp image name change file name to current timestamp
              // get the image name to insert to data base
              var d1 = new Date();
              const img = item2.img.split(".");
              const img_path = img[0].split("/");
              const img_name = `${img_path[0]}/${Math.floor(
                d1.getTime() / 1000
              )}.${img[1]}`;
              var data = {
                id: item2.id,
                vendor_id: Help.getId(item2.vendor_id),
                stock: item2.stock,
                price_buy: item2.price_buy,
                price_sale: item2.price_sale,
                img: item2.img,
                img_name: img_name,
              };
              data.status = true;
              result.push(data);
            }
          }
        });
      });
      return result;
    },

    userRole(val) {
      switch (val) {
        case 1:
          return this.$t("admin");
        case 2:
          return this.$t("owner_store");
        case 3:
          return this.$t("manager");
        case 4:
          return this.$t("assistant");
        case 5:
          return this.$t("staff");
        default:
          return this.$t("unknown_user");
      }
    },
    RoleColor(val) {
      // '1:admin;2:owner;3:manger;4:assistant;5:staff;6:customer'
      switch (val) {
        case 1:
          return "primary";
        case 2:
          return "secondary";
        case 3:
          return "info";
        case 4:
          return "deep-purple lighten-1";
        case 5:
          return "blue-grey";
        default:
          return "blue-grey";
      }
    },
    unitColor(val) {
      switch (val) {
        case "pack":
          return "secondary";
        case "dynamic":
          return "info";
        case "amount":
        default:
          return "primary";
      }
    },
    MyRole(code) {
      const { auth_menus } = this.user;
      // loop menu and check if the code is in the menu code, check in sub menu if the code is in the sub menu code
      // if the code is in the menu code or sub menu code return true
      // if not return false
      var result = false;
      // check auth_menus is not null or undefined
      if (!auth_menus || auth_menus == null || !auth_menus.length) {
        return result;
      }
      // loop auth_menus
      auth_menus.map((item) => {
        if (item.code === code) {
          result = true;
        }
        if (item.menu && item.menu.length) {
          item.menu.map((sub) => {
            if (sub.code === code) {
              result = true;
            }
          });
        }
      });
      // return result;
      return true;
    },
    statusUserStore(item) {
      if (item.stores) {
        if (item.stores.store_id.status) {
          return {
            color: "green",
            status: true,
            title: "account_active",
          };
        } else {
          return {
            color: "red",
            status: false,
            title: "account_inactive",
          };
        }
      } else {
        return {
          color: "blue-grey",
          status: true,
          title: "no_store",
        };
      }
    },
    async fetchMySale() {
      // my_sale API and UI removed - no-op to avoid breaking callers
    },

    getDay(stores) {
      const start_date = stores.store_id.start_date;
      const end_date = stores.store_id.end_date;
      // calculate the difference between two dates
      const differenceInTime = Date.parse(end_date) - Date.parse(start_date);
      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 60 * 60 * 24)
      );
      return differenceInDays;
    },
    getEndDay(stores) {
      const end_date = stores.store_id.end_date;
      // how many day between today's date with the end date
      const differenceInTime = Date.parse(end_date) - Date.parse(new Date());
      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 60 * 60 * 24)
      );
      return differenceInDays;
    },
    userPackage(stores) {
      if (
        stores &&
        stores.store_id &&
        stores.store_id.package &&
        stores.store_id.package.name
      ) {
        const packageName = stores.store_id.package.name;
        const packageDetail = stores.store_id.package;
        switch (packageName) {
          case "starter":
            return {
              color: "blue",
              text: packageName,
              package: packageDetail,
            };
          case "pro":
            return {
              color: "#5b39c91f",
              text: packageName,
              icon: "fal fa-layer-group",
              package: packageDetail,
            };
          case "premium":
            return {
              color: "#D2AF26",
              text: packageName,
              package: packageDetail,
            };
          case "custom":
            return {
              color: "purple",
              text: packageName,
              package: packageDetail,
            };
          default:
            return {
              color: "primary",
              text: packageName,
              package: packageDetail,
            };
        }
      } else {
        return {
          color: "red",
          text: "no_store",
        };
      }
    },
    packageName(name) {
      switch (name) {
        case "starter":
          return {
            color: "secondary",
            text: name,
          };
        case "pro":
          return {
            color: "primary",
            text: name,
          };
        case "premium":
          return {
            color: "amber darken-2",
            text: name,
          };
        case "custom":
          return {
            color: "accent",
            text: name,
          };
        default:
          return {
            color: "primary",
            text: name,
          };
      }
    },
    formatNumber(val) {
      //  format number  with commas
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    branchStatus(val) {
      if (this.user.branch_id && val.id === this.user.branch_id.id) {
        return {
          color: "green",
          icon: "fal fa-check-circle",
          text: "current",
        };
      }
      return {
        color: "red",
        icon: "fal fa-times-circle",
        text: "move",
      };
    },
    orderStatusColor(val) {
      switch (val) {
        case "pending":
          return "orange";
        case "processing":
          return "blue";
        case "completed":
          return "green";
        case "done":
          return "green";
        case "decline":
          return "red";
        case "cancel":
          return "red";
        case "approved":
          return "green";
        case "rejected":
          return "red";
        case "order":
          return "orange";
        case "cooking":
          return "blue";
        case "ready":
          return "success";
        case "cancel":
          return "error";
        case "delivered":
          return "primary";
        case "paid":
          return "green";
        case "accepted":
          return "green";
        default:
          return "orange";
      }
    },

    userActiveOption(val) {
      if (val.is_active) {
        return {
          color: "red",
          icon: "fal fa-lock",
          text: "active",
        };
      }
      return {
        color: "green",
        icon: "fal fa-unlock",
        text: "inactive",
      };
    },
    // (Removed earlier duplicate getProductName; unified implementation is defined later)
    img(item) {
      const _default = "/images/no_photo.jpg";
      try {
        if (item != null && item != undefined && item.img != null) {
          // check if img is contain 'com'
          if (item.img.includes("com")) {
            return item.img;
          } else if (item.img.includes("default")) {
            return _default;
          } else {
            const baseURL = process.env.VUE_APP_BASE_URL;
            return `${baseURL}/uploads/${item.img}`;
          }
        } else {
          return _default;
        }
      } catch (error) {
        return _default;
      }
    },

    pointFormat(item) {
      if (item != null && item != undefined) {
        return Help.pointFormat(item);
      } else {
        return 0;
      }
    },
    price_show(index, value, show_restaurant, packageName) {
      const res = 400000;
      if (packageName === "custom" || index === 3) {
        return this.$t("customize");
      } else if (value === 0) {
        return this.$options.filters.NumberFormat(value);
      }
      if (show_restaurant) {
        return this.$options.filters.NumberFormat(res) + " " + this.$t("month");
      } else {
        return (
          this.$options.filters.NumberFormat(value) + " " + this.$t("month")
        );
      }
    },

    product_count(value) {
      if (
        value === 0 ||
        value === null ||
        value === undefined ||
        value === "0"
      ) {
        return this.$t("customize");
      } else {
        return value + " " + this.$t("item");
      }
    },
    bill_count(value) {
      if (value === 0) {
        return this.$t("unlimited");
      } else {
        return value + " " + this.$t("bill");
      }
    },
    user_count(value) {
      if (value === 0) {
        return this.$t("unlimited");
      } else {
        return value + " " + this.$t("user");
      }
    },
    branch_count(value) {
      if (value === 0) {
        return this.$t("unlimited");
      } else {
        return value + " " + this.$t("branch");
      }
    },
    tableStatusColor(val) {
      // available, busy, reserved
      switch (val) {
        case "available":
          return "green";
        case "busy":
          return "amber";
        case "reserved":
          return "info";
        default:
          return "primary";
      }
    },
    iconStatus(val) {
      // available, busy, reserved
      switch (val) {
        case "available":
          return "fas fa-check-circle";
        case "busy":
          return "fas fa-times-circle";
        case "reserved":
          return "fas fa-lock";
        default:
          return "fas fa-check-circle";
      }
    },

    StringToQRCode(val) {
      // get host url from path
      const baseURL = window.location.origin ?? "https://pos.devla.la";
      const path = `${baseURL}/scan/${val}`;
      // convert string to qr code
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${path}`;
    },

    copyQR(qr) {
      const url = qr.split("&data=")[1];
      // copy to clipboard
      this.copyToClipboard(url);
    },

    TaxCal(val) {
      if (val === null || val === undefined) return 0;
      if (this.taxInclude && this.tax > 0) {
        const amt = val * (this.tax / 100);
        // called filter to format number
        return amt;
      }
      return val;
    },
    TaxPrice(val) {
      if (this.taxInclude && this.tax > 0) {
        const amt = val + val * (this.tax / 100);
        return amt;
      }
      return val;
    },

    copyToClipboard(val) {
      // copy to clipboard
      navigator.clipboard.writeText(val);
      const msg = this.$t("copied");
      this.$toast.success(msg);
    },
    openURL(img) {
      // check if img is contain 'com'
      if (img.includes("com")) {
        window.open(img, "_blank").focus();
        return;
      }
      const url = Help.product(img);
      window.open(url, "_blank").focus();
      return;
    },
    getCategoryName(item) {
      if (!item) return "";
      const pick = (...keys) => {
        for (const key of keys) {
          const value = item[key];
          if (value != null && String(value).trim() !== "") {
            return String(value).trim();
          }
        }
        return "";
      };
      const loc = this.$i18n.locale;
      if (loc === "en") {
        return pick("en_name", "la_name", "th_name", "cn_name");
      }
      if (loc === "th") {
        return pick("th_name", "la_name", "en_name", "cn_name");
      }
      if (loc === "cn" || loc === "ch") {
        return pick("cn_name", "en_name", "la_name", "th_name");
      }
      return pick("la_name", "en_name", "th_name", "cn_name");
    },
    /** Categories for v-select: resolved label with locale + fallback (empty cn_name/th_name). */
    mapCategoriesForSelect(categories) {
      if (!Array.isArray(categories)) {
        return [];
      }
      return categories.map((item) => ({
        ...item,
        category_display: this.getCategoryName(item),
      }));
    },
    getProductName(item) {
      if (!item) return "";
      const key = this.localeKey; // name_en | name_th | name_cn | name_la
      // Fallback priority: Lao → Thai → default
      return item[key] || item.name_la || item.name_th || item.name || "";
    },
    async sendWhatsapp(store) {
      try {
        const { mobile_no, name, end_date } = store;
        const endFormat = this.$options.filters.created_at(end_date);
        const msg =
          `ສະບາຍດີຮ້ານ *${name}* ທີ່ຮັກແພງ! 🙏%0A` +
          `📢 ພວກເຮົາຂໍແຈ້ງມາຍັງທ່ານວ່າ ບັນຊີຂອງຮ້ານຂອງທ່ານຈະໝົດກຳນົດການນຳໃຊ້ໃນວັນທີ *${endFormat}*.✨%0A` +
          `ເພື່ອໃຫ້ທ່ານສາມາດນຳໃຊ້ບໍລິການໄດ້ຢ່າງຕໍ່ເນື່ອງ, ກະລຸນາຕໍ່ອາຍຸບັນຊີໂດຍການສະແກນ QR Code ດ້ານລຸ່ມນີ້. 📱%0A` +
          `🙏 ຂອບໃຈທີ່ໄວ້ວາງໃຈໃຊ້ບໍລິການຂອງພວກເຮົາມາໂດຍຕະຫຼອດ. ຫາກມີຂໍ້ສົງໄສກະລຸນາຕິດຕໍ່ພວກເຮົາໄດ້ທຸກເວລາ. 💬%0A` +
          `🔹 *ຂັ້ນຕອນການຕໍ່ອາຍຸບັນຊີຂອງຮ້ານ* 🔹%0A` +
          `1️⃣ ເຂົ້າໄປທີ່ *ຕັ້ງຄ່າ* -> *ທົ່ວໄປ*%0A` +
          `2️⃣ ເລືອກ *ເພັກເກັດ*%0A` +
          `3️⃣ ຕິກໃສເມນູ *ສິຂ່ຽວ*%0A` +
          `4️⃣ *ສະແກນ QR Code* ເພື່ອຊຳລະ%0A` +
          `💖 ຂອບໃຈທີ່ໃຊ້ບໍລິການ PosSmart!`;
        const url = `https://api.whatsapp.com/send?phone=${mobile_no}&text=${msg}`;
        window.open(url, "_blank").focus();
      } catch (error) {
        console.log(error);
      }
    },
    async checkLocation(store_id, branch_id, table_id) {
      try {
        // First, get store info to check if location is required
        let storeInfo;
        try {
          const { data: storeInfoResponse } = await this.$http.get(
            "/qr/store_info",
            {
              params: {
                store_id,
                branch_id,
                table_id,
              },
            }
          );
          storeInfo = storeInfoResponse.data;
        } catch (storeInfoError) {
          console.error("Failed to fetch store info:", storeInfoError);
          return {
            status: false,
            message:
              storeInfoError?.response?.data?.message ||
              "Failed to fetch store information",
          };
        }

        // If location is required, get real coordinates
        if (storeInfo.require_location) {
          console.log(
            "📍 Location required by store, requesting permission..."
          );

          if (!navigator.geolocation) {
            console.log("Geolocation is not supported by this browser.");
            return { status: false, message: "Geolocation not supported" };
          }

          let position;
          try {
            position = await new Promise((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(resolve, reject, {
                enableHighAccuracy: false,
                timeout: 10000,
                maximumAge: 300000, // Cache location for 5 minutes
              });
            });
          } catch (geoError) {
            // Handle specific geolocation errors
            const errorMessages = {
              1: "Location permission denied",
              2: "Location unavailable (try enabling Wi-Fi or use Chrome DevTools Sensors to mock location)",
              3: "Location request timed out",
            };
            console.warn(
              "Geolocation error:",
              errorMessages[geoError.code] || geoError.message
            );
            return {
              status: false,
              message: errorMessages[geoError.code] || "Location not available",
            };
          }

          if (position) {
            const { latitude, longitude } = position.coords;
            const body = {
              lat: latitude,
              lng: longitude,
              store_id,
              branch_id,
              table_id,
            };
            const { data } = await this.$http.post("/qr/check_location", body);
            return data;
          }

          return { status: false, message: "Location not available" };
        } else {
          // Location not required, send 0,0
          const body = {
            lat: 0,
            lng: 0,
            store_id,
            branch_id,
            table_id,
          };
          const { data } = await this.$http.post("/qr/check_location", body);
          return data;
        }
      } catch (error) {
        console.error("Location check failed:", error);
        return {
          status: false,
          message: error?.response?.data?.message || "Location check failed",
        };
      }
    },

    getRate(currency_id, currencies) {
      // check if form.currency_id is not null and find the currency from the currencies array
      if (currency_id && currencies.length) {
        const currency = currencies.find((cur) => cur.id === currency_id);
        if (currency) {
          return currency.store_exchange_rate ?? currency.exchange_rate;
        }
      } else {
        return 1;
      }
    },
    async hasRole(role) {
      try {
        const { data } = await this.$http.get(`/has_role?role=${role}`);
        return data.status;
      } catch (error) {
        // Return false if user doesn't have the role (400 error)
        // This prevents showing error alerts when checking permissions
        if (error.response && error.response.status === 400) {
          return false;
        }
        console.log("error", error);
        return false;
      }
    },
    /**
     * Returns true when this history row was paid using a customer's stamp loyalty reward.
     * Reads the authoritative `is_stamp_reward` column on the histories row.
     * The first argument is kept for call-site compatibility but is unused.
     */
    isStampRewardLine(_ticket, row) {
      if (!row) return false;
      const v = row.is_stamp_reward;
      return v === true || v === 1 || v === "1" || v === "true";
    },
  },

  // Mix in accessibility features
  mixins: [accessibilityMixin],
};

export { myMixin };
